import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-translation-content-title',
  template: `<div style="margin-bottom: 20px" class="align-right">
    <span class="label label-default">
      <img src="./assets/img/flags/{{ language.lang }}.png" alt="{{ language.lang }}" />
      {{ language.name }}
    </span>
  </div>`,
})
export class TranslationLanguageTitle {
  @Input() language: any;
}

// , OnInit
// implements OnInit
// ngOnInit(): void {
// this.setLanguageName();
// }

// setLanguageName(){
//   switch (lang) {
//     case value:

//       break;

//     default:
//       break;
//   }
// }
